import type { SVGProps } from "react";
export const Check = (props: SVGProps<SVGSVGElement>) => (
	<svg
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		aria-hidden={true}
		{...props}
	>
		<path
			d="M9.54983 17.6538L4.21533 12.3193L5.28433 11.25L9.54983 15.5155L18.7153 6.35001L19.7843 7.41926L9.54983 17.6538Z"
			fill="currentColor"
		/>
	</svg>
);
